export const validators = {
  alpha: (value: string): boolean => /[a-zA-Z]/u.test(value),
  email: (value: string): boolean => /.+@.+\..+/u.test(value),
  isPositiveNumber: (value: string): boolean => /^\d*[1-9]\d*$/u.test(value),
  maxLength: (value: string, length: number): boolean => value.length <= length,
  minLength: (value: string, length: number): boolean => value.length >= length,
  password: (value: string): boolean =>
    /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}/u.test(value),
  required: (value: string): boolean => !!value?.length,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requiredArray: (value: any[]): boolean => value.length > 0,
  requiredObject: (value: object): boolean => Object.keys(value).length > 0,
}
